// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"99":"bambuser-handler","506":"cart-handler","536":"list-handler","889":"purchase-middleware-app"}[chunkId] || chunkId) + "." + {"99":"82cddd0e","280":"382a8d48","506":"46be617f","536":"b03bc3a3","889":"c1eec66a"}[chunkId] + ".js";
};